module.exports = __webpack_public_path__ + "static/media/bg_page51.9c4d69cb.png";